import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="w-full bg-surface-light dark:bg-surface-dark sticky top-0 z-50 shadow-sm border-b border-gray-200 dark:border-gray-700 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative flex h-20 items-center">
          <div className="hidden md:flex space-x-8 items-center">
            <Link className="text-sm uppercase tracking-wide hover:text-primary transition-colors font-medium" to="/">Home</Link>
            <Link className="text-sm uppercase tracking-wide hover:text-primary transition-colors font-medium" to="/corporate">Corporate</Link>
            <Link className="text-sm uppercase tracking-wide hover:text-primary transition-colors font-medium" to="/accessories">Accessories</Link>
          </div>
          <div className="absolute left-1/2 -translate-x-1/2">
            <Link className="flex items-center group" to="/">
              <img src="/sf_logo.webp" alt="Studio Fernandes" style={{width: '120px', height: '156px'}} className="object-contain" />
            </Link>
          </div>
          <div className="hidden md:flex space-x-8 items-center ml-auto">
            <Link className="text-sm uppercase tracking-wide hover:text-primary transition-colors font-medium" to="/our-story">Our Story</Link>
            <Link className="text-sm uppercase tracking-wide hover:text-primary transition-colors font-medium" to="/visit-store">Visit Store</Link>
          </div>
          <div className="md:hidden flex items-center ml-auto">
            <button
              className="text-gray-500 hover:text-primary focus:outline-none"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span className="material-icons text-2xl">{isOpen ? 'close' : 'menu'}</span>
            </button>
          </div>
        </div>
      </div>
      {isOpen && (
        <div className="md:hidden border-t border-gray-200 dark:border-gray-700 bg-surface-light dark:bg-surface-dark">
          <div className="px-4 py-2">
            <Link onClick={() => setIsOpen(false)} className="block py-3 text-sm uppercase tracking-wide hover:text-primary transition-colors font-medium" to="/">Home</Link>
            <Link onClick={() => setIsOpen(false)} className="block py-3 text-sm uppercase tracking-wide hover:text-primary transition-colors font-medium" to="/corporate">Corporate</Link>
            <Link onClick={() => setIsOpen(false)} className="block py-3 text-sm uppercase tracking-wide hover:text-primary transition-colors font-medium" to="/accessories">Accessories</Link>
            <Link onClick={() => setIsOpen(false)} className="block py-3 text-sm uppercase tracking-wide hover:text-primary transition-colors font-medium" to="/our-story">Our Story</Link>
            <Link onClick={() => setIsOpen(false)} className="block py-3 text-sm uppercase tracking-wide hover:text-primary transition-colors font-medium" to="/visit-store">Visit Store</Link>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navigation;
